import { action, makeObservable, observable } from 'mobx';

class PopupStore {
  isOpenPopup = false;

  popupName = '';

  lastPopupName = '';

  spinInfo = null;

  connectionError = false;

  constructor() {
    makeObservable(this, {
      spinInfo: observable,
      popupName: observable,
      isOpenPopup: observable,
      connectionError: observable,
      lastPopupName: observable,
      open: action.bound,
      close: action.bound,
      setRoundInfo: action.bound,
      onConnectionError: action.bound,
      setPopupName: action.bound,
      setIsOpenPopup: action.bound,
      setLastPopupName: action.bound,
    });
  }

  onConnectionError(state) {
    this.connectionError = state;
  }

  setIsOpenPopup(bool) {
    this.isOpenPopup = bool;
  }

  setPopupName(name) {
    this.popupName = name;
  }

  setLastPopupName(name) {
    this.lastPopupName = name;
  }

  setRoundInfo(data) {
    this.spinInfo = data;
  }

  open({ name, lastPopupName = '', spinInfo = this.spinInfo }) {
    this.setIsOpenPopup(true);
    this.setPopupName(name);
    this.setLastPopupName(lastPopupName);
    this.setRoundInfo(spinInfo);
  }

  close = () => {
    this.setRoundInfo(null);
    this.isOpenPopup = false;
    this.popupName = '';
  };

  popupBack = () => {
    this.setPopupName(this.lastPopupName);
    this.setLastPopupName('');
  };
}

export const popupStore = new PopupStore();
